// extracted by mini-css-extract-plugin
module.exports = {"main":"priceRate_main__liDRr"};